import API from '../api-service';
import axios from 'axios';

const baseUri = 'authentication';
const path = process.env.NODE_ENV === 'production'
  ? 'https://play.bizlibrary.com/prod'
  : 'https://play.dev.bizlibrary.com/dev';

export default {
  getAuthentications() {
    return API.get(baseUri);
  },
  postAuthentication(body) {
    return API.post(baseUri, body);
  },
  patchAuthentication(body, syncguid) {
    return API.patch(`${baseUri}/${syncguid}`, body);
  },
  deleteAuthentication(syncguid) {
    return API.delete(`${baseUri}/${syncguid}`);
  },
  testAuthentication(syncguid) {
    const params = {
      syncguid,
      redirect: `${window.location.origin}/auth-success`,
      session: 'preview-session',
    };
    return axios.get(`${path}/authentication/saml2-link`, { params }).then(res => {
      window.open(res.data);
    });
  },
  getAuthenticationMetadata(syncguid) {
    return `${path}/auth/saml2/${syncguid}/metadata`;
  },
};
